import { createAction, props } from '@ngrx/store';
import {
  PageSize,
  ReportDataMap,
  ReportingTemplateRequest,
  ReportSectionConfigurationWithOrder,
  ReportsTemplateListType,
  ReportTemplate,
  ReportTemplateFormType,
  ReportType
} from '@capital-access/reporting/common';
export const loadAllTemplates = createAction(
  '[Reporting] Load Reporting Dashboard',
  props<{
    silentRefresh?: boolean;
  }>()
);
export const searchTextUpdate = createAction('[Reporting] Search Text Update', props<{ searchText: string }>());
export const loadAllTemplatesSuccess = createAction(
  '[Reporting] Load Reporting Dashboard Success',
  props<{ data: ReportTemplate[] }>()
);
export const loadAllTemplatesFailure = createAction(
  '[Reporting] Load Reporting Dashboard Failure',
  props<{ error: unknown }>()
);
export const openCreateReportingTemplateDrawer = createAction(
  '[Reporting] Open Create Report Template Drawer',
  props<{
    reportType: ReportType;
    actionType: ReportTemplateFormType;
    settings?: string | null;
    reportModule?: boolean;
  }>()
);
export const resetCreateFeatureReducer = createAction('[Reporting Librayr] Reset Create Feature Reducer');
export const clearCreateReportSectionSettings = createAction('[Reporting] Clear Create Report Section Settings');
export const submitReportForm = createAction(
  '[Reporting] Submit Report Template Form',
  props<{ formData: ReportingTemplateRequest; actionType: ReportTemplateFormType }>()
);
export const submitReportFormDuplicate = createAction(
  '[Reporting] Submit Report Template Duplicate Form',
  props<{ formData: ReportingTemplateRequest; actionType: ReportTemplateFormType }>()
);
export const updateReportForm = createAction(
  '[Reporting] Update Report Template Form',
  props<{ formData: ReportingTemplateRequest }>()
);
export const changeActiveReportingTemplateListType = createAction(
  '[Reporting] Change Active Reporting Template List Type',
  props<{ reportsListType: ReportsTemplateListType }>()
);
export const saveCreateReportForm = createAction(
  '[Reporting] Save Create Report Template Form',
  props<{ formData: ReportingTemplateRequest }>()
);
export const resetCreateReportForm = createAction('[Reporting] Reset Create Report Template Form');
export const drawerAction = createAction(
  '[Reporting Drawer] Drawer Action',
  props<{ actionType: ReportTemplateFormType }>()
);
export const editTemplateSuccess = createAction(
  '[Reporting Drawer] Edit Reporting Template Success',
  props<{ templateId: number }>()
);
export const editTemplateFailure = createAction('[Reporting Drawer] Edit Reporting Template Failed');
export const createTemplateSuccess = createAction(
  '[Reporting Drawer] Create Reporting Template Success',
  props<{ templateId: number }>()
);
export const createDuplicateTemplateSuccess = createAction(
  '[Reporting Drawer] Create Duplicate Reporting Template Success',
  props<{ templateName: string; templateId: number }>()
);
export const createTemplateFailure = createAction('[Reporting Drawer] Create Reporting Template Failed');
export const deleteTemplateSuccess = createAction(
  '[Reporting Drawer] Delete Reporting Template Success',
  props<{ template: ReportTemplate }>()
);
export const deleteTemplateFailure = createAction(
  '[Reporting Drawer] Delete Reporting Template Failed',
  props<{ template?: ReportTemplate }>()
);
export const openEditDuplicateReportingTemplateDrawer = createAction(
  '[Reporting] Open Edit Duplicate Report Template Drawer',
  props<{ template: ReportTemplate; actionType: ReportTemplateFormType }>()
);
export const openSelectedTemplate = createAction(
  '[Reporting Library] Open Selected Template',
  props<{ data: ReportTemplate; reportType: ReportType }>()
);
export const setSelectedTemplateForPreview = createAction(
  '[Reporting Library] Set Selected Template For Preview',
  props<{ selectedTemplate: ReportTemplate; skipZoomReset?: boolean }>()
);
export const setSelectedReportSectionsForPreview = createAction(
  '[Reporting Library] Set Selected Report Sections For Preview',
  props<{
    createReportSectionSettings: string;
    reportSections: ReportSectionConfigurationWithOrder[];
    templatePageSize: PageSize;
  }>()
);
export const setReportSetingSettings = createAction(
  '[Reporting Library] Set ReportSection Settings',
  props<{ createReportSectionSettings: string }>()
);
export const setCombinedOwnershipEnabled = createAction(
  '[Template Designer] Set Combined Ownership Enabled',
  props<{ enabled: boolean }>()
);
export const setNotesFeatureEnabled = createAction(
  '[Template Library] Set Notes Feature Enabled',
  props<{ enabled: boolean }>()
);
export const clearTemplateLibraryStore = createAction('[Reporting Library] Clear Template Library Store');
export const deletingTemplate = createAction(
  '[Reporting Drawer] Deleting Reporting Template',
  props<{ templateId: number }>()
);
export const updateLandingPageReportData = createAction(
  ' [Reporting Library] Update Report Data',
  props<{ reportData: ReportDataMap }>()
);
